var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.80005,
    y: 1.2,
    width: 25,
    height: 25,
    rx: 9,
    fill: "#DE350B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5045 13.7219L18.7998 11.4181C19.4028 10.8129 19.3998 9.83472 18.7932 9.23318C18.1866 8.63164 17.2061 8.63458 16.6032 9.23974L14.3191 11.5323L11.996 9.20483C11.3926 8.6002 10.412 8.59813 9.806 9.2002C9.19995 9.80227 9.19787 10.7805 9.80135 11.3851L12.1356 13.7238L9.8519 16.0158C9.24896 16.621 9.2519 17.5992 9.85848 18.2008C10.4651 18.8023 11.4456 18.7994 12.0485 18.1942L14.321 15.9134L16.5504 18.147C17.1539 18.7517 18.1344 18.7537 18.7404 18.1517C19.3465 17.5496 19.3486 16.5714 18.7451 15.9667L16.5045 13.7219Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.80005,
    y: 1.2,
    width: 25,
    height: 25,
    rx: 9,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus1);
export default __webpack_public_path__ + "static/media/Status(1).0630c79b39919e57eae8e99d1427f9ba.svg";
export { ForwardRef as ReactComponent };